import { IorganizationBusinessData } from '../../../../../types/bussines';
import ConfigurationTabLoader from './ConfigurationTabLoader/ConfigurationTabLoader';
import { Button } from 'antd';
import PlusButton from '../../../../../assets/images/searchBar/plusButton';
import ConfigurationList from './ConfigurationList/ConfigurationList';
import { useParams } from 'react-router-dom';
import { getOrganizationConfigTableByOrganizationId } from '../../../../../services/product-configuration.service';
import { SWR_KEYS } from '../../../../../constants/constants';
import useSWR from 'swr';
import { IConfigurationData } from '../../../../../types/product.configuration.types';
import useConfigurationGlobalState from './configurationGlobalState';
import InactiveConfigModal from './InactiveConfigModal/InactiveConfigModal';
import DeleteConfigModal from './DeleteConfigModal/DeleteConfigModal';
import ReviewConfigModal from './ReviewConfigModal/ReviewConfigModal';
import AddConfigModal from './AddConfigModal/AddConfigModal';
import ToolsAsociatedConfigModal from './ToolsAsociatedConfigModal/ToolsAsociatedConfigModal';
import useFiltersState from '../../../../../state/useFiltersState';
import { useEffect, useState } from 'react';
import './ConfigurationTab.scss';

const ConfigurationTab = ({ organizationData }: { organizationData?: IorganizationBusinessData }) => {
  const { organizationId } = useParams<{ organizationId: string }>();
  const [totalConfigurationCount, setTotalConfigurationCount] = useState(0);

  const {
    isToolsAsociatedConfigModalOpen,
    setIsToolsAsociatedConfigModalOpen,
    setConfigUnit,
    isInactiveConfigModalOpen,
    setIsInactiveConfigModalOpen,
    isDeleteConfigModalOpen,
    setIsDeleteConfigModalOpen,
    isReviewConfigModalOpen,
    setIsReviewConfigModalOpen,
    isAddConfigModalOpen,
    setIsAddConfigModalOpen,
    searchText
  } = useConfigurationGlobalState();

  const { configurationFilters } = useFiltersState();

  const filtersQuery =
    configurationFilters && configurationFilters.length > 0 ? `filters=${JSON.stringify(configurationFilters)}` : '';

  const {
    mutate: mutateGetOrganizationConfigByOrganizationId,
    data: getOrganizationConfigByOrganizationIdData,
    isLoading: isLoadingGetOrganizationConfigByOrganizationId
  } = useSWR(
    [SWR_KEYS.organizationConfigList, organizationId, filtersQuery, searchText],
    () => getOrganizationConfigTableByOrganizationId(Number(organizationId), filtersQuery, searchText),
    {
      suspense: false
    }
  );

  const isEmptyData = totalConfigurationCount === 0;

  const handleCloseUnitsConfigModal = () => {
    setIsToolsAsociatedConfigModalOpen(false);
    setConfigUnit(null);
  };

  const handleCloseInactiveConfigModal = () => {
    setIsInactiveConfigModalOpen(false);
    setConfigUnit(null);
  };

  const handleCloseDeleteConfigModal = () => {
    setIsDeleteConfigModalOpen(false);
    setConfigUnit(null);
  };

  const handleCloseReviewConfigModal = () => {
    setIsReviewConfigModalOpen(false);
  };

  const handleCloseAddConfigModal = () => {
    setIsAddConfigModalOpen(false);
  };

  const handleOpenAddConfigModal = () => {
    setIsAddConfigModalOpen(true);
  };

  useEffect(() => {
    if (getOrganizationConfigByOrganizationIdData && totalConfigurationCount === 0) {
      setTotalConfigurationCount(getOrganizationConfigByOrganizationIdData?.length);
    }
  }, [getOrganizationConfigByOrganizationIdData, totalConfigurationCount, mutateGetOrganizationConfigByOrganizationId]);

  if (!organizationData) return <ConfigurationTabLoader />;

  return (
    <div className="configurationTab">
      {isReviewConfigModalOpen && (
        <ReviewConfigModal organizationData={organizationData} closeModalCallback={handleCloseReviewConfigModal} />
      )}
      {isToolsAsociatedConfigModalOpen && (
        <ToolsAsociatedConfigModal closeModalCallback={handleCloseUnitsConfigModal} />
      )}
      {isInactiveConfigModalOpen && (
        <InactiveConfigModal
          closeModalCallback={handleCloseInactiveConfigModal}
          mutateGetOrganizationConfigByOrganizationId={mutateGetOrganizationConfigByOrganizationId}
        />
      )}
      {isDeleteConfigModalOpen && (
        <DeleteConfigModal
          closeModalCallback={handleCloseDeleteConfigModal}
          mutateGetOrganizationConfigByOrganizationId={mutateGetOrganizationConfigByOrganizationId}
        />
      )}
      {isAddConfigModalOpen && (
        <AddConfigModal
          organizationData={organizationData}
          closeModalCallback={handleCloseAddConfigModal}
          mutateGetOrganizationConfigByOrganizationId={mutateGetOrganizationConfigByOrganizationId}
        />
      )}
      <div className="configurationTabContainer">
        <div className="configurationHeader">
          <div className="sectionTitle">Configuraciones de herramientas</div>
          <div className="sectionDescription">
            Aquí puedes administrar las configuraciones predeterminadas que se aplican a las empresas.
          </div>
        </div>

        {isEmptyData && (
          <>
            <Button
              className="creatButtonWithIcon"
              icon={
                <div className="iconStyle">
                  <PlusButton className="iconPositionButton" />
                </div>
              }
              onClick={handleOpenAddConfigModal}
            >
              Agregar configuraciones
            </Button>
            <div className="noConfigurationsMessage">La empresa no tiene configuraciones asociadas</div>
          </>
        )}

        {!isEmptyData && (
          <ConfigurationList
            getOrganizationConfigByOrganizationIdData={
              getOrganizationConfigByOrganizationIdData as IConfigurationData[]
            }
            isLoadingGetOrganizationConfigByOrganizationId={isLoadingGetOrganizationConfigByOrganizationId}
            totalConfigurationCount={totalConfigurationCount}
          />
        )}
      </div>
    </div>
  );
};

export default ConfigurationTab;
